goog.provide("shadow.js.shim.module$$tiptap$extension_bold");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_bold");
shadow.js.shim.module$$tiptap$extension_bold = shadow.js.nativeProvides["@tiptap/extension-bold"] = shadow$bridge("@tiptap/extension-bold");
module$shadow_js_shim_module$$tiptap$extension_bold.default = shadow.js.shim.module$$tiptap$extension_bold;
